import type { IWarehouseApi } from "../../../api/WarehouseApi";
import { type INavigationStore, Screens } from "../../../stores/navigation";
import {
  isBoxId,
  isProductId,
  openBoxScreenById,
  openProductScreenById,
} from "../../shared/use-cases/entity-navigation";

export type ResolvedReferenceId =
  | { kind: "product"; id: string }
  | { kind: "box"; id: string }
  | { kind: "unknown"; id: string };

export function resolveReferenceId(id: string): ResolvedReferenceId {
  const normalizedId = id.trim();
  if (isProductId(normalizedId)) {
    return { kind: "product", id: normalizedId };
  }
  if (isBoxId(normalizedId)) {
    return { kind: "box", id: normalizedId };
  }
  return { kind: "unknown", id: normalizedId };
}

export function resolveParentBoxId(
  parentId: string | null | undefined,
): string {
  const normalized = parentId?.trim() || "";
  if (!isBoxId(normalized)) {
    return "";
  }
  return normalized;
}

export async function openHistoryProductById(input: {
  api: IWarehouseApi;
  navigationStore: INavigationStore;
  productId: string;
  setActionError: (message: string) => void;
}): Promise<boolean> {
  const trimmedProductId = input.productId.trim();
  if (!isProductId(trimmedProductId)) {
    return false;
  }

  return openProductScreenById({
    api: input.api,
    navigationStore: input.navigationStore,
    productId: trimmedProductId,
    onNotFound: () => {
      input.setActionError("Товар из истории не найден");
    },
    onError: (error) => {
      input.setActionError(
        error instanceof Error
          ? error.message
          : "Не удалось открыть товар из истории",
      );
    },
  });
}

export async function openBoxByIdWithActionError(input: {
  api: IWarehouseApi;
  navigationStore: INavigationStore;
  boxId: string;
  setActionError: (message: string) => void;
}): Promise<boolean> {
  const trimmedBoxId = input.boxId.trim();
  if (!isBoxId(trimmedBoxId)) {
    return false;
  }

  return openBoxScreenById({
    api: input.api,
    navigationStore: input.navigationStore,
    boxId: trimmedBoxId,
    onNotFound: () => {
      input.setActionError("Коробка не найдена");
    },
    onError: (error) => {
      input.setActionError(
        error instanceof Error
          ? error.message
          : "Не удалось открыть карточку коробки",
      );
    },
  });
}

export function openBoxesListScreen(navigationStore: INavigationStore): void {
  navigationStore.setScreen(Screens.BoxesList, {
    title: "Список коробок",
  });
}
